import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { firstValueFrom } from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';

@Component({
  selector: 'app-dialog-pax',
  templateUrl: './dialog-pax.component.html',
  styleUrls: ['./dialog-pax.component.css'],
})
export class DialogPaxComponent implements OnInit {
  isLoading: boolean = true;
  displayedColumns: any[] = [
    'num',
    'grupo',
    'nombre',
    'apellido',
    'fechaNacimiento',
    'genero',
    'edad',
    'talla',
    'peso',
    'altura',
    'correo',
    'pais',
    'restricciones',
    'alergias',
    'condiciones',
  ];

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fileService: FileService,
    public dialogRef: MatDialogRef<DialogPaxComponent>,
  ) {}

  ngOnInit(): void {
    const assignedPassengers =
      this.data.element.lstPaX
        ?.filter((pax: any) => pax.passengerId != null && !!pax?.estado)
        .map((pax: any) => pax.passengerId) || [];
    console.log({
      assignedPassengers,
    });
    if (assignedPassengers.length === 0) {
      this.isLoading = false;
      this.dataSource = new MatTableDataSource(this.data.element.lstPaX);
      return;
    }

    firstValueFrom(
      this.fileService.getPassengersByIds({
        passengerIds: assignedPassengers,
        passengerFields: {
          id: true,
          firstName: true,
          lastName: true,
          dateOfBirth: true,
          gender: true,
          age: true,
          size: true,
          weight: true,
          height: true,
          country: true,
          restriccionesAlimentarias: true,
          alergias: true,
          condicionesMedicas: true,
          email: true,
        },
      }),
    ).then((response) => {
      console.log({
        response,
      });
      const passengers = response.getPassengers || [];
      this.data.element.lstPaX.forEach((pax: any) => {
        const passengerData = passengers.find(
          (passenger: any) => passenger.id === pax.passengerId,
        );

        if (passengerData) {
          pax.firstName = passengerData.firstName;
          pax.lastName = passengerData.lastName;
          pax.dateOfBirth = passengerData.dateOfBirth;
          pax.gender = passengerData.gender;
          pax.age = passengerData.age;
          pax.size = passengerData.size;
          pax.weight = passengerData.weight;
          pax.height = passengerData.height;
          pax.country = passengerData.country;
          pax.restriccionesAlimentarias =
            passengerData.restriccionesAlimentarias;
          pax.alergias = passengerData.alergias;
          pax.condicionesMedicas = passengerData.condicionesMedicas;
        }
      });
      this.dataSource = new MatTableDataSource(this.data.element.lstPaX);
      this.isLoading = false;
    });
  }
}
